import { FC, Fragment, JSX, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';
import { AddRounded as AddRoundedIcon } from '@mui/icons-material';
//components
import IngredientsTable from 'components/main/Ingredients/IngredientsTable';
import { IngredientModal } from 'components/main/Ingredients/IngredientModal';
// constant, styles, reducer, graphql
import { flexCenterBetween } from 'styles/commonComponentStyle';
import {
  ADD_INGREDIENT_ROUTE,
  ADD_NEW_TEXT,
  IMPORT_INGREDIENTS_TEXT,
  INGREDIENTS_TEXT,
} from 'constants/index';

const Ingredients: FC = (): JSX.Element => {
  const navigate = useNavigate();
  const [modalOpen, setModalOpen] = useState(false);
  const [modalMessages] = useState<string[]>([]);

  const handleCloseModal = (resetFile: () => void) => {
    setModalOpen(false);
    resetFile();
  };

  const handleDownloadSample = () => {
    // Path to the sample file in public folder
    const sampleFilePath = '/Ingredient-sample-file.csv';

    // Create a temporary link to trigger download
    const link = document.createElement('a');
    link.href = sampleFilePath;
    link.download = 'Ingredient-sample-file.csv';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Fragment>
      <Box sx={flexCenterBetween}>
        <Typography variant="h5">{INGREDIENTS_TEXT}</Typography>
        <Box sx={{ display: 'flex', gap: 2 }}>
          <Button color="primary" variant="outlined" onClick={() => setModalOpen(true)}>
            <AddRoundedIcon sx={{ mr: 1 }} />
            {IMPORT_INGREDIENTS_TEXT}
          </Button>
          <Button
            color="primary"
            variant="contained"
            onClick={() => navigate(ADD_INGREDIENT_ROUTE)}
            id="add-ingredient-btn">
            <AddRoundedIcon sx={{ mr: 1 }} />
            {ADD_NEW_TEXT}
          </Button>
        </Box>
      </Box>

      <IngredientsTable />

      <IngredientModal
        open={modalOpen}
        messages={modalMessages}
        onClose={() => handleCloseModal(() => setModalOpen(false))}
        onDownloadSample={handleDownloadSample}
      />
    </Fragment>
  );
};

export default Ingredients;
